import { el } from 'redom';

import AnchorLabel from './label';

class AnchorButton {

  constructor(options) {

    this.opened = false;
    this.onClick = options.onClick;

    this.anchorLabel = new AnchorLabel({
      placeholder: options.placeholder,
      value: options.value
    });
    this.anchorArrow = null;

    this.initializeAnchorArrow();

    this.el = el('button.anchor-button-main', {
      type: 'button',
      onclick: this.handleAnchorButtonClick.bind(this)
    }, [this.anchorLabel, this.anchorArrow]);

  }

  initializeAnchorArrow() {

    this.anchorArrow = el('span.wind-unwind-indicator', {
      class: 'unwind'
    });

  }

  handleAnchorButtonClick() {

    const self = this;

    if (this.opened === true) {
      return;
    }
    this.open();
    // I had to do this because, this click is also captured by the outside click event handler, 
    // which is going to be registered in the self.onClick() call. 
    // Took some time to understand.
    // So, now, I am deferring the self.onClick call, so the event bubbling would end before the 
    // registration of outside click event down the line.
    setTimeout(function someTimeLater() {
      self.onClick();
    }, 1);

  }

  toggleArrow() {

    if (this.opened === true) {
      this.close();
    } else {
      this.open();
    }

  }

  configure(attributes) {

    this.opened = false;
    this.close();
    this.anchorLabel.update(attributes);

  }

  open() {

    this.opened = true;
    this.anchorArrow.classList.remove('unwind');
    this.anchorArrow.classList.add('wind');

  }

  close() {

    this.opened = false;
    this.anchorArrow.classList.add('unwind');
    this.anchorArrow.classList.remove('wind');

  }

}

export default AnchorButton;